

import React, { memo } from 'react';
import cx from 'classnames';
import HeatmapCell from './HeatmapCell';





function HeatmapMonthCell({ month }) {
  return (
    <HeatmapCell
      className={cx('heatmap-month-cell')}>

      {month}
    </HeatmapCell>);

}

export default memo(HeatmapMonthCell);